import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import InsuranceDetailsDashboard from "./InsuranceDetailsDashboard";
import { useGetAnalyticsApiDataQuery } from "features/banking/BankingApiSlice";

const InsuranceCharts = () => {
  // const [locationType, setLocationType] = useState("district_name")

  const [analyticsdata, setAnalyticsData] = useState([]);

  let payload = {
    service_name: "Insurance",
    // location_type: locationType,
    // location_name: locationName,
    // status: statusName,
    // date_range:dateRange,
    // product_category: "",
    product_name: "Cattle",

    // top_number: 10,
    // pending:activeTabPending,
  };
  // const { data: apiData, refetch } = useGetAnalyticsApiDataQuery(payload);
  // const [showLoading, setShowLoading] = useState(true);

  // useEffect(() => {
  //   if (apiData != undefined) {
  //     setAnalyticsData(apiData);
  //     setShowLoading(false);
  //   }
  // }, [apiData]);

  // const processLocationData = () => {
  //   if (!analyticsdata?.top_performing?.locations) return [];

  //   return analyticsdata.top_performing?.locations.map((location) => ({
  //     name: location.state_name,
  //     y: location.count,
  //   }));
  // };

  // const locationChartOptions = {
  //   chart: { type: "bar" },
  //   colors: ["#FFA07A"],
  //   xaxis: { categories: processLocationData().map((item) => item.name) },
  //   plotOptions: { bar: { columnWidth: "15%" } },
  //   yaxis: { labels: { formatter: (val) => Math.round(val) } },
  //   series: [
  //     { name: "Leads", data: processLocationData().map((item) => item.y) },
  //   ],
  //   dataLabels: { enabled: false },
  //   legend: { show: false },
  // };


  
  // const processBreedData = (type) => {
  //   const breedCounts = {};
  //   analyticsdata?.records?.results?.forEach((record) => {
  //     record?.lead_details?.forEach((lead) => {
  //       lead?.service_details?.cattle_data?.forEach((cattle) => {
  //         const species = cattle?.asset_details?.cattle_species;
  //         const breed = cattle?.asset_details?.cattle_breed || "Unknown";
  //         if (species === type) {
  //           breedCounts[breed] = (breedCounts[breed] || 0) + 1;
  //         }
  //       });
  //     });
  //   });
  
  //   return Object.entries(breedCounts).map(([x, y]) => ({ x, y }));
  // };
  
  
  // const cowBreedData = processBreedData("Cow");

  // const cowBreedChartOptions = {
  //   chart: { type: "bar" },
  //   colors: ["#f4c2c2"],
  //   xaxis: {
  //     categories: cowBreedData.map((item) =>
  //       item?.x?.length > 6 ? item.x.substring(0, 6) + "..." : item.x || "Unknown"
  //     ),
  //     labels: { rotate: 0 },
  //   },
  //   plotOptions: { bar: { columnWidth: "50%" } },
  //   series: [
  //     {
  //       name: "Cow Breeds",
  //       data: cowBreedData.map((item) => item?.y || 0),
  //     },
  //   ],
  //   dataLabels: { enabled: false },
  //   legend: { show: false },
  // };
 
   
  // const buffaloBreedData = processBreedData("Buffalo");

  // const buffaloBreedChartOptions = {
  //   chart: { type: "bar" },
  //   colors: ["#f4c2c2"],
  //   xaxis: {
  //     categories: buffaloBreedData.map((item) =>
  //       item?.x?.length > 6 ? item.x.substring(0, 6) + "..." : item.x || "Unknown"
  //     ),
  //     labels: { rotate: 0 },
  //   },
  //   plotOptions: { bar: { columnWidth: "50%" } },
  //   series: [
  //     {
  //       name: "Cow Breeds",
  //       data: buffaloBreedData.map((item) => item?.y || 0),
  //     },
  //   ],
  //   dataLabels: { enabled: false },
  //   legend: { show: false },
  // };
  return (
    <Box
      sx={{ width: "100%", padding: 2, borderRadius: 2, position: "relative" }}
    >
    

      <InsuranceDetailsDashboard
        // locationChartOptions={locationChartOptions}
        // series={locationChartOptions.series}
      />
    </Box>
  );
};

export default InsuranceCharts;
